"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanCheckout = void 0;
const Leaf = __importStar(require("leaf-ts"));
const planCheckout_html_R_1 = require("./planCheckout/planCheckout.html.R");
const planCheckout_html_R_2 = require("./planCheckout/planCheckout.theme/business/planCheckout.html.R");
const planCheckout_html_R_3 = require("./planCheckout/planCheckout.theme/genesis/planCheckout.html.R");
const web_1 = require("@branch-ts/web");
const log_consensus_1 = require("@branch-ts/log-consensus");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
const versetUserProfileMechanism_1 = require("../versetUserProfileMechanism");
class PlanCheckout extends planCheckout_html_R_1.R.PlanCheckout {
    static show(option = {}) {
        const checkout = new PlanCheckout(option);
        void checkout.asWindow.show();
        return checkout;
    }
    constructor(option = {}) {
        super();
        this.currentSubscription = null;
        this.currentCheckoutURI = null;
        this.purchasing = false;
        this.checkoutStarted = false;
        this.mustCheckSubscription = false;
        this.refreshing = null;
        this.asWindow = new web_1.WindowBehavior(this, { intrinsicSize: { width: 560, height: 660 } })
            .setTitle("Explore with Verset")
            .allowMinimize(false);
        this.stages = new web_1.StagesBehavior(this).defines({ state: "loading", recovery: "hide" });
        this.present = web_1.PresentMechanism.about(this).lifeCycle(async (about) => {
            await about.declare("present");
            const refreshWhenVisible = () => {
                if (this.asWindow.isShow)
                    void this.refresh();
            };
            versetUserProfileMechanism_1.VersetUserProfileMechanism.events.of.refresh.listenBy(this, refreshWhenVisible);
            window.addEventListener("focus", refreshWhenVisible);
            log_consensus_1.Logger.log("Verset conversion", { step: "offerShown" });
            await this.refresh();
            await about.declare("hang");
            versetUserProfileMechanism_1.VersetUserProfileMechanism.events.stopListenBy(this);
            window.removeEventListener("focus", refreshWhenVisible);
        });
        this.VM.offerTitle = option.exhausted ? "Keep exploring with Verset" : "Explore a new way to work with AI";
        this.VM.offerDescription = option.exhausted
            ? "Your included AI usage is used up. Go further with Standard, or wait for your allowance to refresh. Your notes and documents remain available."
            : "We’re exploring how people and AI can think and act together—with you directing the work. Join us in bringing that exploration into everyday practice.";
        this.VM.refreshHint = option.exhausted && option.refreshAt
            ? `Your included allowance refreshes ${new Date(option.refreshAt).toLocaleString()}.`
            : "Free users are part of this exploration too.";
    }
    get server() {
        return versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer();
    }
    refresh() {
        if (this.refreshing)
            return this.refreshing;
        this.refreshing = this.loadSubscription().finally(() => this.refreshing = null);
        return this.refreshing;
    }
    async loadSubscription() {
        try {
            const [result, reason] = await this.server.rpcs.VersetUserSubscriptionService.getMySubscription({});
            if (reason || !result) {
                this.VM.hint = "We could not load your subscription. Please check again.";
                return;
            }
            this.currentSubscription = result.subscription;
            this.mustCheckSubscription = false;
            const paid = result.subscription.state.startsWith("active") && result.subscription.plan && result.subscription.plan !== "free";
            this.currentCheckoutURI = paid && !result.subscription.due ? null : result.checkoutURI?.trim() || null;
            this.VM.checkoutURI = this.currentCheckoutURI || "";
            this.planCardsList.empty();
            for (const plan of result.plans.filter(plan => plan.name !== "free")) {
                this.planCardsList.push(new PlanCardItem(this, plan));
            }
            if (this.purchasing)
                return;
            if (paid && this.checkoutStarted && !result.subscription.due) {
                this.stages.set("state", "ready");
                this.VM.hint = "Your subscription is active. Return to your work and retry when you’re ready.";
            }
            else if (this.currentCheckoutURI) {
                this.checkoutStarted = true;
                this.stages.set("state", "checkout");
                this.VM.hint = "Continue your pending checkout. No new subscription will be created.";
            }
            else {
                this.stages.set("state", "plan");
                this.VM.hint = result.subscription.due || result.subscription.state === "bindCollecting"
                    ? "Payment is still being collected. Check again or contact support for help; do not start another subscription."
                    : paid ? "Standard is your current plan." : "";
            }
        }
        catch {
            this.VM.hint = "We could not load your subscription. Please check again.";
        }
    }
    canPurchase(plan) {
        return !this.purchasing && !this.mustCheckSubscription && !this.currentCheckoutURI
            && this.currentSubscription?.state === "free"
            && plan.name !== "free";
    }
    async purchasePlan(plan) {
        if (!this.canPurchase(plan))
            return;
        this.purchasing = true;
        this.checkoutStarted = true;
        this.planCardsList.forEach(card => card.syncButton(true));
        this.VM.hint = "Preparing secure Stripe checkout…";
        // Open during the click, before awaiting RPC, to retain browser user activation.
        const checkoutWindow = window.open("", "verset-subscription-checkout");
        try {
            const [result, reason] = await this.server.rpcs.VersetUserSubscriptionService.setupInitialSubscription({
                planName: plan.name,
                paymentMethod: "stripe-subscription-adaptor",
            });
            if (reason || !result) {
                checkoutWindow?.close();
                this.mustCheckSubscription = true;
                this.VM.hint = "We could not prepare checkout. Check your subscription before trying again.";
                return;
            }
            this.currentCheckoutURI = result.checkoutURI;
            this.VM.checkoutURI = result.checkoutURI;
            this.stages.set("state", "checkout");
            this.openCheckout(checkoutWindow);
        }
        catch {
            checkoutWindow?.close();
            this.mustCheckSubscription = true;
            this.VM.hint = "Checkout preparation could not be confirmed. Check your subscription before trying again.";
        }
        finally {
            this.purchasing = false;
            this.planCardsList.forEach(card => card.syncButton());
        }
    }
    openCheckout(checkoutWindow) {
        if (!checkoutWindow || checkoutWindow.closed) {
            this.stages.set("recovery", "show");
            this.VM.hint = "Your browser blocked checkout. Open it below, or copy the secure link.";
            return;
        }
        checkoutWindow.location.href = this.currentCheckoutURI || "";
        this.stages.set("recovery", "hide");
        this.VM.hint = "Stripe is open in another tab. Payment is not confirmed yet. Keep your work open here.";
        log_consensus_1.Logger.log("Verset conversion", { step: "checkoutOpened", kind: "subscription" });
    }
    onClickCheckoutBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        if (!this.currentCheckoutURI)
            return;
        this.checkoutStarted = true;
        this.openCheckout(window.open("", "verset-subscription-checkout"));
    }
    async onClickCopyCheckoutLinkBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        if (!this.currentCheckoutURI)
            return;
        try {
            await navigator.clipboard.writeText(this.currentCheckoutURI);
            this.VM.hint = "Secure checkout link copied.";
        }
        catch {
            this.VM.hint = "Copy was blocked. Select and copy the secure link below.";
        }
    }
    onClickRefreshBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        void this.refresh();
    }
    onClickDismissBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        this.asWindow.hide();
        log_consensus_1.Logger.log("Verset conversion", { step: this.stages.get("state") === "ready" ? "returnedToWork" : "offerDismissed" });
    }
}
exports.PlanCheckout = PlanCheckout;
class PlanCardItem extends planCheckout_html_R_1.R.PlanCheckout.PlanCardItem {
    constructor(view, plan) {
        super();
        this.view = view;
        this.plan = plan;
        this.VM.planName = plan.name;
        this.VM.priceAmount = new Intl.NumberFormat("en-US", { style: "currency", currency: plan.currency }).format(plan.amount ?? Number(plan.exactAmount));
        this.VM.usageAllowance = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(plan.quotaPoint / 10_000);
        this.VM.duration = plan.duration;
        this.syncButton();
    }
    syncButton(busy = false) {
        this.UI.purchaseBtn.disabled = busy || !this.view.canPurchase(this.plan);
        this.VM.purchaseLabel = busy ? "Preparing checkout…" : this.UI.purchaseBtn.disabled ? "Current or pending plan" : "Continue with Standard";
    }
    onClickPurchaseBtn(e) {
        e?.stopPropagation();
        e?.preventDefault();
        void this.view.purchasePlan(this.plan);
    }
}
Leaf.WidgetThemeCenter.about(planCheckout_html_R_1.R.PlanCheckout).add("business", planCheckout_html_R_2.R.PlanCheckout.generator);
Leaf.WidgetThemeCenter.about(planCheckout_html_R_1.R.PlanCheckout).add("genesis", planCheckout_html_R_3.R.PlanCheckout.generator);
